import cn from 'classnames';
import Markdown from 'components/markdown';
import { ISectionTextimageComboFields } from 'global';
import RibbonText from 'modules/content-cms/components/ribbon-text';
import renderDocument from 'modules/content-cms/util/render-document';
import Link from 'next/link';
import React, { CSSProperties } from 'react';
import { isAbsoluteUrl } from 'utils/url';
import ContentContainer from '../components/content-container';
import Image from '../components/image';
import Title from '../components/title';

const TextImageCombo: React.FC<ISectionTextimageComboFields> = ({
  title,
  subTitle,
  hideTitle,
  disableSpacing,
  mirrorColumns,
  backgroundColor,
  image,
  testImage,
  imageMobile,
  testImageMobile,
  imageLink,
  imageMaximumWidth,
  imagePlacement,
  text,
  framelessImage,
  richTitle,
}) => {
  const renderImage = () => {
    const imageProps = {
      style: {} as CSSProperties,
    };

    if (!image) return '';

    if (imageMaximumWidth) {
      imageProps.style.maxWidth = `${imageMaximumWidth}px`;
      imageProps.style.width = '100%';
    }

    if (framelessImage) {
      imageProps.style.marginBottom = '-9px';
    }

    const _image = testImage || image;
    const _imageMobile = testImageMobile || imageMobile;
    if (imageLink) {
      const child = (
        <>
          <div className={cn(imageMobile && 'hidden lg:block')}>
            <Image {..._image} />
          </div>
          {_imageMobile && (
            <div className="lg:hidden">
              <Image {..._imageMobile} />
            </div>
          )}
        </>
      );
      if (isAbsoluteUrl(imageLink)) {
        return (
          <div {...imageProps}>
            <a href={imageLink}>{child}</a>
          </div>
        );
      } else {
        return (
          (<div {...imageProps}>
            <Link href={imageLink} passHref>
              {child}
            </Link>
          </div>)
        );
      }
    } else {
      return (
        <div {...imageProps}>
          <div className={cn(_imageMobile && 'hidden lg:block')}>
            <Image {..._image} />
          </div>
          <div className="lg:hidden">
            {_imageMobile && (
              <div className="lg:hidden">
                <Image {..._imageMobile} />
              </div>
            )}
          </div>
        </div>
      );
    }
  };

  return (
    <ContentContainer
      disableSpacing={disableSpacing}
      backgroundColor={backgroundColor ? backgroundColor : 'white'}
    >
      {richTitle ? (
        <RibbonText text={richTitle} />
      ) : title && hideTitle !== true ? (
        <>
          {subTitle && (
            <div className="text-center text-sm font-black uppercase leading-loose ">
              {subTitle}
            </div>
          )}
          <Title>{title}</Title>
        </>
      ) : null}

      <div
        className={cn(
          'flex flex-col items-center',
          mirrorColumns && mirrorColumns === true
            ? 'md:flex-row-reverse'
            : 'md:flex-row'
        )}
      >
        <div
          className={cn(
            !text
              ? 'flex w-full'
              : 'flex w-full items-center pb-6 pr-2 md:w-1/2 md:pb-0',
            imagePlacement &&
              imagePlacement === 'left' &&
              'justify-start text-left',
            imagePlacement &&
              imagePlacement === 'center' &&
              'justify-center text-center',
            imagePlacement &&
              imagePlacement === 'right' &&
              'justify-end text-right'
          )}
        >
          {renderImage()}
        </div>

        {text && (
          <Markdown className="w-full md:w-1/2">
            {renderDocument(text)}
          </Markdown>
        )}
      </div>
    </ContentContainer>
  );
};

export default TextImageCombo;
